import React from 'react'
import { Link } from 'react-static'
import styles from './styles.module.css'

export default ({ paginator }) => (
    <div className={styles.pagination}>
        {
            paginator.totalPages > 1 && 
            <div className={styles.links}>
                { paginator.previousPath ? <Link to={paginator.previousPath}>&lt;&lt; newer posts</Link> : <span />  }
                <span>{ paginator.nextPath && paginator.previousPath ? ' | ' : ''  }</span>
                { paginator.nextPath ? <Link to={paginator.nextPath}>older posts &gt;&gt;</Link> : <span />  }
            </div>
        }
    </div>
)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/PaginationLinks/index.js